import React, { Component } from 'react';
import { func, object } from 'prop-types';
import Clock from 'react-feather/dist/icons/clock';
import { Link } from 'react-router-dom';
import { contains } from 'ramda';

import { connect} from 'react-redux';
import { LOGOUT_REQUEST } from '../../constants/ActionTypes';
import { logout } from '../../actions/session/sessionActions';

import Layout from '../Layout';
import Header from '../Header';
import LoadingState from '../LoadingState';

import cx from 'classnames';
import s from './ReVerify.css';


export class ReVerify extends Component {
    static propTypes = {
        history: object,
        loadingState: object,
        location: object,
        logoutRequest: func.isRequired,
        match: object,
    };

    componentDidMount() {
        this.props.logoutRequest();
    }

    render = () => {
        const isLoading = contains(LOGOUT_REQUEST, this.props.loadingState.requests || []);

        return (
            <Layout column fullscreen className={s.component}>
                <Header />
                <div className={s.reVerify}>
                    {isLoading &&
                        <div className={s.loadingState}>
                            <p>Logging out...</p>
                            <LoadingState context="logout" />
                        </div>
                    }
                    <Clock
                        color="#ff9027"
                        size={50}
                        className={s.svg}
                        id="errorMessage"
                    />
                    <em className={s.verticalSpacing}>
                        This session has now expired. Please re-authenticate to continue viewing this secure text message.
                    </em>
                    <Link
                        className={cx(s.btn, s.primary)}
                        id="submitConfirmIdentity"
                        to={`/verify/${this.props.match.params.conversationHash}`}
                    >
                        Confirm Identity
                    </Link>
                </div>
            </Layout>
        )
    }
}

const mapStateToProps = state => ({
    loadingState: state.loadingState,
});

const mapDispatchToProps = dispatch => ({
    logoutRequest: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReVerify);